export default __webpack_public_path__ + "static/media/FotoSibyl.991dbbaa.jfif";